import React from 'react';
import { useTranslation } from '@michelin/central-provider';
import { PageTitle } from 'components/v3/PageTitle/PageTitle';

export function ContactsModule() {
  const { t } = useTranslation();
  return (
    <>
      <PageTitle
        eyebrow={t('Contacts & Approvals')}
        title={t('Key Contacts')}
        subtitle={t('ERS Managers, PO/Billing contacts, and approval limits')}
      />
    </>
  );
}
